import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { DISTANCE_OPTIONS, PROVIDER_REGISTRATION_TITLE_PROPS } from "~/utils/providerRegistrationHelpers";
import BooleanRadioGroup from "./BooleanRadioGroup";

const Distance = () => {
  const { control } = useFormContext();

  return (
    <Stack direction="column" spacing={4}>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          Are you able to commute to your work location independently?
        </Typography>
        <BooleanRadioGroup control={control} name="distance.commuteIndependently" />
      </Stack>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          How far are you willing to travel to work?
        </Typography>
        <Controller
          control={control}
          defaultValue={null}
          name="distance.travelDistance"
          render={({ field }) => (
            <FormControl>
              <RadioGroup
                {...field}
                onChange={(e) => {
                  field.onChange(Number(e.target.value));
                }}
              >
                {DISTANCE_OPTIONS.map(([distanceValue, distanceLabel]) => (
                  <FormControlLabel key={distanceValue} control={<Radio />} label={distanceLabel} value={distanceValue} />
                ))}
              </RadioGroup>
            </FormControl>
          )}
        />
      </Stack>
    </Stack>
  );
};

export default Distance;
